import { useQuery } from "@tanstack/react-query";
import { FetchAppointmentsAndPatientsController } from "../../payment-dashboard-v2/controller";
import { useMyAccessProfileV2 } from "../../apis/tryst/get-my-access-profile";

export function getAppointmentsQueryNameV3({
  clinicId,
  startDate,
  endDate,
}: {
  clinicId?: string;
  startDate?: string;
  endDate?: string;
} = {}) {
  const keyName = ["appointments-receipts-v2"];
  if (clinicId) {
    keyName.push(clinicId);
  }
  if (startDate) {
    keyName.push(startDate);
  }
  if (endDate) {
    keyName.push(endDate);
  }

  return keyName;
}

export default function useGetAllAppointmentsV2({
  clinicId,
  startDate,
  endDate,
}: {
  clinicId: string;
  startDate: string;
  endDate: string;
}) {
  const endDateObj = endDate ? new Date(endDate) : new Date(startDate);
  if (!endDate) {
    endDateObj.setHours(endDateObj.getHours() + 24);
  }

  const endDateString = endDateObj.toISOString();
  const { data: myAccessProfile } = useMyAccessProfileV2({ clinicId });

  return useQuery(
    getAppointmentsQueryNameV3({
      clinicId,
      startDate,
      endDate: endDateString,
    }),
    async () => {
      const result = await FetchAppointmentsAndPatientsController({
        archive: false,
        cid: clinicId!,
        startDate: new Date(startDate),
        endDate: new Date(endDateString),
        oids: myAccessProfile?.doctors.map((d) => d.oid)!,
      });

      return {
        success: true,
        response: {
          apt: result?.response?.apt || [],
          countResponse: {},
        },
      };
    },
    {
      enabled: !!clinicId && !!myAccessProfile,
      staleTime: 5 * 60 * 1000,
    }
  );
}
